import { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

const TZ = 'Asia/Kolkata';

function SBClock() {
  const [now, setNow] = useState(() => new Date());
  useEffect(() => {
    const id = setInterval(() => setNow(new Date()), 1000);
    return () => clearInterval(id);
  }, []);
  const time = now.toLocaleTimeString('en-IN', { timeZone: TZ, hour12: false });
  const date = now.toLocaleDateString('en-IN', {
    timeZone: TZ, weekday: 'short', day: '2-digit', month: 'short',
  });
  return (
    <div className="sb-clock sb-mono">
      <div className="sb-clock-time">
        {time} <span className="sb-clock-ist">IST</span>
      </div>
      <div>{date}, 2026</div>
    </div>
  );
}

// SVG icons (inline, no external dep)
function IconDashboard() {
  return (
    <svg viewBox="0 0 20 20" width={17} height={17} fill="none" stroke="currentColor" strokeWidth="1.6">
      <rect x="2.5" y="2.5" width="6" height="8" rx="1.5" />
      <rect x="11.5" y="2.5" width="6" height="4" rx="1.5" />
      <rect x="2.5" y="13.5" width="6" height="4" rx="1.5" />
      <rect x="11.5" y="9.5" width="6" height="8" rx="1.5" />
    </svg>
  );
}
function IconBookings() {
  return (
    <svg viewBox="0 0 20 20" width={17} height={17} fill="none" stroke="currentColor" strokeWidth="1.6">
      <rect x="2.5" y="4.5" width="15" height="13" rx="2" />
      <path d="M2.5 8.5h15" />
      <path d="M6 2.5v3M14 2.5v3" strokeLinecap="round" />
    </svg>
  );
}
function IconCalendar() {
  return (
    <svg viewBox="0 0 20 20" width={17} height={17} fill="none" stroke="currentColor" strokeWidth="1.6">
      <rect x="2.5" y="4" width="15" height="13.5" rx="2" />
      <path d="M2.5 9h15M7 12.5h2M11 12.5h2M7 15h2" strokeLinecap="round" />
    </svg>
  );
}
function IconFacilities() {
  return (
    <svg viewBox="0 0 20 20" width={17} height={17} fill="none" stroke="currentColor" strokeWidth="1.6">
      <path d="M3 17.5V8l7-4.5L17 8v9.5" strokeLinejoin="round" />
      <path d="M8 17.5v-5h4v5" />
    </svg>
  );
}
function IconUsers() {
  return (
    <svg viewBox="0 0 20 20" width={17} height={17} fill="none" stroke="currentColor" strokeWidth="1.6">
      <circle cx="10" cy="7" r="3" />
      <path d="M3.5 17c.6-3.2 3.2-5 6.5-5s5.9 1.8 6.5 5" strokeLinecap="round" />
    </svg>
  );
}
function IconSun() {
  return (
    <svg viewBox="0 0 18 18" width={14} height={14} fill="none" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round">
      <circle cx="9" cy="9" r="3.2" />
      <path d="M9 1.8v1.6M9 14.6v1.6M1.8 9h1.6M14.6 9h1.6M3.7 3.7l1.2 1.2M13.1 13.1l1.2 1.2M3.7 14.3l1.2-1.2M13.1 4.9l1.2-1.2" />
    </svg>
  );
}
function IconMoon() {
  return (
    <svg viewBox="0 0 18 18" width={14} height={14} fill="none" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round">
      <path d="M15 11.2A6.4 6.4 0 1 1 6.8 3a5 5 0 0 0 8.2 8.2z" />
    </svg>
  );
}
function IconLogout() {
  return (
    <svg viewBox="0 0 16 16" width={14} height={14} fill="none" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round">
      <path d="M9 3H4.5a1 1 0 0 0-1 1v8a1 1 0 0 0 1 1H9M11 5l3 3-3 3M6 8h8" />
    </svg>
  );
}
function IconCollapse() {
  return (
    <svg viewBox="0 0 16 16" width={14} height={14} fill="none" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round">
      <path d="M6 4l-3 4 3 4M11 4l-3 4 3 4" />
    </svg>
  );
}
function IconRefunds() {
  return (
    <svg viewBox="0 0 20 20" width={17} height={17} fill="none" stroke="currentColor" strokeWidth="1.6">
      <path d="M3 10a7 7 0 1 0 14 0A7 7 0 0 0 3 10z" />
      <path d="M10 7v3l2 2" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M7 4.5l-3 .5.5 3" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  );
}

/** Derive initials from a username string. */
function initials(name = '') {
  const parts = name.trim().split(/[\s_-]+/).filter(Boolean);
  if (parts.length >= 2) return (parts[0][0] + parts[1][0]).toUpperCase();
  return name.slice(0, 2).toUpperCase();
}

// Avatar colour cycle — same as design
const AV_COLORS = ['c0', 'c1', 'c2', 'c3', 'c4'];
function avatarColor(name = '') {
  let h = 0;
  for (let i = 0; i < name.length; i++) h = (h * 31 + name.charCodeAt(i)) % 5;
  return AV_COLORS[h];
}

function IconHamburger() {
  return (
    <svg viewBox="0 0 20 20" width={20} height={20} fill="none" stroke="currentColor" strokeWidth="1.7" strokeLinecap="round">
      <path d="M3 6h14M3 10h14M3 14h14" />
    </svg>
  );
}
function IconMore() {
  return (
    <svg viewBox="0 0 20 20" width={20} height={20} fill="currentColor">
      <circle cx="4" cy="10" r="1.4" /><circle cx="10" cy="10" r="1.4" /><circle cx="16" cy="10" r="1.4" />
    </svg>
  );
}
function IconClose() {
  return (
    <svg viewBox="0 0 14 14" width={15} height={15} fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round">
      <path d="M3 3l8 8M11 3l-8 8" />
    </svg>
  );
}

export const NAV_ITEMS = [
  { id: 'dashboard',  to: '/admin',            exact: true,  label: 'Dashboard',  icon: <IconDashboard /> },
  { id: 'bookings',   to: '/admin/bookings',    exact: false, label: 'Bookings',   icon: <IconBookings /> },
  { id: 'calendar',   to: '/admin/calendar',    exact: false, label: 'Calendar',   icon: <IconCalendar /> },
  { id: 'refunds',    to: '/admin/refunds',     exact: false, label: 'Refunds',    icon: <IconRefunds />, badge: true },
];
export const NAV_CONFIG = [
  { id: 'facilities', to: '/admin/facilities',  exact: false, label: 'Facilities', icon: <IconFacilities />, ownerOnly: true },
  { id: 'users',      to: '/admin/users',        exact: false, label: 'Users',      icon: <IconUsers />, ownerOnly: true },
];

/** Shared active-path test used by rail, top-nav, tab bar, and drawer. */
function isActivePath(pathname, item) {
  return item.exact ? pathname === item.to : pathname.startsWith(item.to);
}

export default function AdminSideRail({ collapsed, toggleCollapsed, isDark, toggleTheme, refundCount = 0, lockCollapsed = false }) {
  const { user, logout } = useAuth();
  const location = useLocation();

  const isActive = (item) => {
    if (item.exact) return location.pathname === item.to;
    return location.pathname.startsWith(item.to);
  };

  const ini = initials(user?.username || 'AD');
  const avc = avatarColor(user?.username || '');

  const isOwner = user?.role === 'owner';
  const roleLabel = isOwner ? 'Owner' : 'Location Admin';
  const scope = isOwner ? 'All locations' : `${user?.assigned_locations?.length || 0} location(s)`;

  return (
    <aside className="sb-rail">
      {/* Brand */}
      <div className="sb-brand">
        <div className="sb-mark">SB</div>
        <div style={{ flex: 1, minWidth: 0 }}>
          <div className="sb-brand-name">Sport Bloc</div>
          <div className="sb-brand-sub">Operator</div>
        </div>
        <button
          className="sb-brand-mode-btn"
          onClick={toggleTheme}
          title={isDark ? 'Switch to light mode' : 'Switch to dark mode'}
        >
          {isDark ? <IconSun /> : <IconMoon />}
        </button>
      </div>

      {/* Nav */}
      <nav className="sb-nav">
        <div className="sb-nav-lbl">Operations</div>
        {NAV_ITEMS.map(item => (
          <Link
            key={item.id}
            to={item.to}
            className={`sb-nav-link ${isActive(item) ? 'active' : ''}`}
            data-label={item.label}
          >
            <span className="sb-ico">{item.icon}</span>
            <span>{item.label}</span>
            {item.badge && refundCount > 0 && (
              <span className="sb-count warn">{refundCount}</span>
            )}
          </Link>
        ))}

        {isOwner && (
          <>
            <div className="sb-nav-lbl">Configure</div>
            {NAV_CONFIG.map(item => (
              <Link
                key={item.id}
                to={item.to}
                className={`sb-nav-link ${isActive(item) ? 'active' : ''}`}
                data-label={item.label}
              >
                <span className="sb-ico">{item.icon}</span>
                <span>{item.label}</span>
              </Link>
            ))}
          </>
        )}
      </nav>

      {/* Clock */}
      <SBClock />

      {/* User */}
      <div className="sb-me">
        <div
          className={`sb-av ${avc}`}
          style={{ width: 30, height: 30, fontSize: 11, flexShrink: 0 }}
        >
          {ini}
        </div>
        <div className="sb-me-info" style={{ flex: 1, minWidth: 0 }}>
          <div className="sb-me-who">{user?.username || 'admin'}</div>
          <div className="sb-me-role">{roleLabel} · {scope}</div>
        </div>
        <button className="sb-me-btn" onClick={logout} title="Sign out">
          <IconLogout />
        </button>
        {!lockCollapsed && (
          <button
            className="sb-me-btn"
            onClick={toggleCollapsed}
            title={collapsed ? 'Expand sidebar' : 'Collapse sidebar'}
            style={{ transform: collapsed ? 'rotate(180deg)' : 'none', transition: 'transform .2s' }}
          >
            <IconCollapse />
          </button>
        )}
      </div>
    </aside>
  );
}

/* ── Mobile top bar (≤720px) ───────────────────────────────────────────────── */
export function MobileTopBar({ title, isDark, toggleTheme, onMenu }) {
  return (
    <div className="sb-mobile-bar">
      <button className="sb-btn ghost icon" onClick={onMenu} title="Menu" style={{ padding: 6 }}>
        <IconHamburger />
      </button>
      <div className="sb-mark">SB</div>
      <div className="sb-mobile-title">{title}</div>
      <button className="sb-btn ghost icon" onClick={toggleTheme} title="Toggle theme" style={{ padding: 6 }}>
        {isDark ? <IconSun /> : <IconMoon />}
      </button>
    </div>
  );
}

/* ── Mobile bottom tab bar ──────────────────────────────────────────────────── */
export function MobileTabBar({ refundCount = 0, onMore }) {
  const location = useLocation();
  const moreActive = ['/admin/facilities', '/admin/users'].some(p => location.pathname.startsWith(p));
  return (
    <nav className="sb-mobile-tabbar">
      {NAV_ITEMS.map(n => {
        const active = isActivePath(location.pathname, n);
        const showBadge = n.id === 'refunds' && refundCount > 0;
        return (
          <Link key={n.id} to={n.to} className={`sb-tab ${active ? 'active' : ''}`}>
            <span className="sb-tab-ico">{n.icon}</span>
            {showBadge && <span className="sb-tab-badge">{refundCount}</span>}
            <span>{n.label}</span>
          </Link>
        );
      })}
      <button className={`sb-tab ${moreActive ? 'active' : ''}`} onClick={onMore} type="button">
        <span className="sb-tab-ico"><IconMore /></span>
        <span>More</span>
      </button>
    </nav>
  );
}

/* ── Mobile slide-over drawer (full nav + account) ─────────────────────────── */
export function MobileDrawer({ open, onClose, refundCount = 0 }) {
  const { user, logout } = useAuth();
  const location = useLocation();
  const isOwner = user?.role === 'owner';
  const ini = initials(user?.username || 'AD');
  const avc = avatarColor(user?.username || '');
  const roleLabel = isOwner ? 'Owner' : 'Location Admin';

  return (
    <aside className={`sb-mobile-drawer ${open ? 'open' : ''}`}>
      <div className="sb-brand" style={{ paddingBottom: 18, marginBottom: 12 }}>
        <div className="sb-mark">SB</div>
        <div style={{ flex: 1, minWidth: 0 }}>
          <div className="sb-brand-name">Sport Bloc</div>
          <div className="sb-brand-sub">Operator</div>
        </div>
        <button className="sb-btn ghost icon" onClick={onClose} style={{ padding: 6 }}><IconClose /></button>
      </div>

      <nav className="sb-nav" style={{ flex: 1, overflowY: 'auto' }}>
        <div className="sb-nav-lbl">Operations</div>
        {NAV_ITEMS.map(n => (
          <Link key={n.id} to={n.to} onClick={onClose}
                className={`sb-nav-link ${isActivePath(location.pathname, n) ? 'active' : ''}`}>
            <span className="sb-ico">{n.icon}</span>
            <span>{n.label}</span>
            {n.badge && refundCount > 0 && <span className="sb-count warn">{refundCount}</span>}
          </Link>
        ))}
        {isOwner && (
          <>
            <div className="sb-nav-lbl">Configure</div>
            {NAV_CONFIG.map(n => (
              <Link key={n.id} to={n.to} onClick={onClose}
                    className={`sb-nav-link ${isActivePath(location.pathname, n) ? 'active' : ''}`}>
                <span className="sb-ico">{n.icon}</span>
                <span>{n.label}</span>
              </Link>
            ))}
          </>
        )}
      </nav>

      <div className="sb-me">
        <div className={`sb-av ${avc}`} style={{ width: 32, height: 32, fontSize: 12, flexShrink: 0 }}>{ini}</div>
        <div className="sb-me-info" style={{ flex: 1, minWidth: 0 }}>
          <div className="sb-me-who">{user?.username || 'admin'}</div>
          <div className="sb-me-role">{roleLabel}</div>
        </div>
        <button className="sb-me-btn" onClick={logout} title="Sign out"><IconLogout /></button>
      </div>
    </aside>
  );
}

/* ── Top-nav variant (Tweaks → nav="top") ──────────────────────────────────── */
export function TopNav({ isDark, toggleTheme, refundCount = 0 }) {
  const { user, logout } = useAuth();
  const location = useLocation();
  const isOwner = user?.role === 'owner';
  const ini = initials(user?.username || 'AD');
  const avc = avatarColor(user?.username || '');
  const items = isOwner ? [...NAV_ITEMS, ...NAV_CONFIG] : NAV_ITEMS;

  return (
    <div className="sb-topnav">
      <div className="sb-topnav-brand">
        <div className="sb-mark" style={{ width: 26, height: 26, borderRadius: 7, fontSize: 11 }}>SB</div>
        <div style={{ fontWeight: 600, fontSize: 14, letterSpacing: '-.01em' }}>Sport Bloc</div>
      </div>
      <nav className="sb-topnav-nav">
        {items.map(n => (
          <Link key={n.id} to={n.to}
                className={`sb-nav-link ${isActivePath(location.pathname, n) ? 'active' : ''}`}
                style={{ display: 'inline-flex', alignItems: 'center', gap: 6 }}>
            <span className="sb-ico">{n.icon}</span><span>{n.label}</span>
            {n.badge && refundCount > 0 && <span className="sb-count warn">{refundCount}</span>}
          </Link>
        ))}
      </nav>
      <div style={{ flex: 1 }} />
      <button className="sb-btn ghost icon" onClick={toggleTheme} title="Toggle theme">
        {isDark ? <IconSun /> : <IconMoon />}
      </button>
      <SBClock />
      <div style={{ display: 'flex', alignItems: 'center', gap: 8, paddingLeft: 14, borderLeft: '1px solid var(--line-soft)' }}>
        <div className={`sb-av ${avc}`} style={{ width: 28, height: 28, fontSize: 11 }}>{ini}</div>
        <button className="sb-me-btn" onClick={logout} title="Sign out"><IconLogout /></button>
      </div>
    </div>
  );
}
